module.exports = __webpack_public_path__ + "img/San Marino.71843734.svg";